import React from 'react';
import { useTranslation } from 'react-i18next';

import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '../../_ui/Modal/Modal';
import Button from '../../modules/Button/Button';

function IntegrationModal({
  title,
  close,
  isOpen,
  onDonIntegration,
  onZagsInit,
  setCheck,
  loadingIntegration = false,
  helperText = false,
  kdpGbdflStatus = null,
  kdpZagsStatus = null,
  clearResources,
  setShowHelperText
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        if (typeof setCheck === 'function') {
          setCheck(false);
        }
        if (typeof clearResources === 'function') {
          clearResources();
          setShowHelperText(false);
        }
        close();
      }}
      disableBackdropClick={true}
    >
      <DialogContent>
        <div style={{ fontSize: '18px' }}>{t(`${title}`)}</div>
        {helperText && (
          <div
            style={{ marginTop: '10px', fontSize: '14px', color: 'red', fontWeight: 500 }}
          >
            {t('loginPage_integration_REJECT')}
          </div>
        )}
        {(kdpGbdflStatus || kdpZagsStatus) && (
          <div style={{ marginTop: '10px', fontSize: '14px', fontWeight: 500 }}>
            {`${t('loginPage_integration_status')}:`}
            <div style={{ fontWeight: 'normal', marginTop: '4px' }}>
              {kdpGbdflStatus === 'NOT_FOUND' || kdpZagsStatus === 'NOT_FOUND' ? (
                <span style={{ color: 'red' }}>
                  {t('loginPage_integration_NOT_FOUND')}
                </span>
              ) : kdpGbdflStatus === 'PENDING' ? (
                <span style={{ color: '#5250F9' }}>
                  {t('loginPage_integration_PENDING')} <CircularProgress size={14} />
                </span>
              ) : kdpGbdflStatus === 'INVALID' ? (
                <span style={{ color: 'red' }}>{t('loginPage_integration_INVALID')}</span>
              ) : kdpGbdflStatus === 'TIMEOUT' ? (
                <span style={{ color: 'red' }}>{t('loginPage_integration_TIMEOUT')}</span>
              ) : null}
            </div>
          </div>
        )}

      </DialogContent>
      <DialogActions>
        <Button
          disabled={loadingIntegration}
          text={t('home_donAgree')}
          onClick={onDonIntegration}
          color="primary"
        />

        <Button
          text={t('home_agree')}
          color="secondary"
          onClick={onZagsInit}
          loading={loadingIntegration}
        />
      </DialogActions>
    </Modal>
  );
}

export default IntegrationModal;
